import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SpinnerService{
    private animar = new BehaviorSubject<boolean>(true);
    animar$ = this.animar.asObservable();
  
    renderizarAnimacao(value: boolean) {
      this.animar.next(value);
    }

}